/* eslint-disable camelcase */
import antden_US from 'antd/lib/locale-provider/en_US';

const enUS = {
  messages: {},
  antd: antden_US,
  locale: 'en-US',
  code: 'en_US',
};

export default enUS;
